export default __webpack_public_path__ + "static/media/stanford.da4a97ee.jpg";